import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateReturnOrderComponent } from './create-return-order.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosOrderObservationsModule } from 'src/app/shared/pos-order-observations/pos-order-observations.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [CreateReturnOrderComponent],
  imports: [
    CommonModule,
    PosTableModule,
    PosOrderObservationsModule,
    AccordionModule,
    FormsModule,
    NgxMaskModule,
    NgSelectModule
  ],
  exports: [CreateReturnOrderComponent]
})

export class CreateReturnOrderModule { }
